/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Icon } from 'sarsaparilla';
import get from 'lodash/get';
import { navigateToSearchResults, updateSearchCriteria } from '../actions/search';
import { OCCUPANTS_TYPE, VEHICLE_LENGTH_TYPE } from '../constants/filters/camping';

function SearchFilterPill({ title, isFgParam, onRemove, uiFilterName, filter }) {
    const dispatch = useDispatch();
    const search = useSelector((state) => state.search);
    const onRemoveFilter = () => {
        if (!isFgParam) {
            onRemove(uiFilterName, filter);
        } else {
            const fgParams = get(search, 'fg', []);
            const clearParams = fgParams.filter((item) => {
                if (filter === OCCUPANTS_TYPE.key || filter === VEHICLE_LENGTH_TYPE.key) {
                    return !item.includes(filter);
                }
                if (item !== filter) {
                    return true;
                }
                return false;
            });
            dispatch(updateSearchCriteria('fg', clearParams));
            dispatch(navigateToSearchResults());
        }
    };
    return (
        <div className="filter-pill-container">
            <div className={'filter-pill'}>
                <span>{title}</span>
                <Button
                    type="button"
                    size="xs"
                    onClick={onRemoveFilter}
                    appearance={'link'}
                    iconBeforeElement={<Icon iconName="close" />}
                    screenReaderTextBefore={`Remove ${title} Filter`}
                    clickTagCategory="Search"
                    clickTagAction={`Remove ${title} Filter`}
                    clickTagLabel="Active Filters Section"
                />
            </div>
        </div>
    );
}

SearchFilterPill.propTypes = {
    title: PropTypes.string,
    uiFilterName: PropTypes.string,
    filter: PropTypes.any,
    onRemove: PropTypes.func,
    isFgParam: PropTypes.bool,
};

export default SearchFilterPill;
